<div *ngIf="isInModal" class="{{ itemsSelected.length ? 'text-success' : 'text-dark' }} font-size- fw-bold ">
  {{ placeHolder | translate }}
</div>
<div class="w-100 d-flex">
  <div
    class="button-previous d-flex p-2 justify-content-center align-items-center {{
      disableScrollBefore() ? 'text-info opacity-50' : 'text-white pointer'
    }}"
    #previousPaginator
    *ngIf="showPaginationControls()"
    (click)="handlePaginatorClick('before')"
    (mousedown)="handlePaginatorPress('before', $event)"
    (touchend)="stopInterval()"
  >
    <i class="icon icon-angle-left icon-48"></i>
  </div>
  <div
    class="chip-wrapper d-flex flex-fill position-relative text-black  filters align-items-center {{
      rowWrap() ? 'w-100 flex-wrap' : 'overflow-x-scroll'
    }}"
    #listContainer
  >
    <ng-container *ngFor="let item of internalItems; let i = index">
      <div
        #chip
        *ngIf="item.label && item.label !== ''"
        (click)="toggleCheck(item, i)"
        [ngClass]="{
          'active-pill': item.selected,          
        }"
        class="py-2 px-4 bg-light btn text-dark chip me-2 rounded-2"
        [@pop]="hasAnimation()"
      >
        <i *ngIf="item.icon" class="icon icon-{{ item.icon }} me-2"></i>
        {{ item.label | entitiesHtml | translate }}
      </div>
    </ng-container>
  </div>
  <div
    class="button-next d-flex p-2 justify-content-center align-items-center {{
      disableScrollAfter() ? 'text-info opacity-50' : 'text-white pointer'
    }}"
    #nextPaginator
    *ngIf="showPaginationControls()"
    (click)="handlePaginatorClick('after')"
    (mousedown)="handlePaginatorPress('after', $event)"
    (touchend)="stopInterval()"
  >
    <i class="icon icon-angle-right icon-48"></i>
  </div>
</div>
<hr *ngIf="isInModal" />
